import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './style.css';
import { onKeyUpEnterOrSpace } from '../../utils';

const StyledAccordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .1)',
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(Accordion);

const StyledAccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    // borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 46,
    '&$expanded': {
      minHeight: 46,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(AccordionSummary);

const StyledAccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(AccordionDetails);

const CustomAccordion = (props) => {
  const { list = [], expandAll = false, itemClick } = props;
  const [expanded, setExpanded] = useState('');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <div className="custom-accordions-container">
      {list.length
        ? list.map((item) => (
            <StyledAccordion
              key={item.date}
              expanded={expanded === item.date || expandAll}
              onChange={handleChange(item.date)}
            >
              <StyledAccordionSummary expandIcon={expandAll ? null : <ExpandMoreIcon />}>
                <Typography id={`publish-by-period-date-${item.date}`}>{item.date}</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <div className="date-days">
                  {item.days?.length
                    ? item.days.map((day) => (
                        <div
                          key={day.value}
                          className={`date-day ${day.checked ? 'checked' : 'unchecked'}`}
                          onClick={() => itemClick(day)}
                          style={{}}
                          id={`publish-by-period-day-${day.value}-${item.date}`}
                          tabIndex={0}
                          onKeyUp={(e) => onKeyUpEnterOrSpace(e, () => itemClick(day))}
                        >
                          <span>{day.value}</span>
                          {day.edited === 1 && (
                            <div
                              id={`publish-by-period-day-red-corner-${day.value}-${item.date}`}
                              style={{
                                position: 'absolute',
                                right: -1,
                                top: -1,
                                border: 'solid',
                                borderTopWidth: 4,
                                borderRightWidth: 4,
                                borderLeftWidth: 4,
                                borderTopColor: 'red',
                                borderLeftColor: 'transparent',
                                borderRightColor: 'red',
                                borderBottomColor: 'transparent',
                              }}
                            />
                          )}
                        </div>
                      ))
                    : null}
                </div>
              </StyledAccordionDetails>
            </StyledAccordion>
          ))
        : null}
    </div>
  );
};

export default CustomAccordion;
